import BaseModel from './BaseModel'

class OrderModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            carId: ['carId', undefined, value => value],
            mileage: ['mileage', undefined, value => value],
            status: ['status', undefined, value => value],
            sum: ['sum', undefined, value => value],
            date: ['date', undefined, value => value],
            station: ['station', undefined],
            recommendation: ['recommendation', undefined],
            works: ['works', undefined, value => value],
            items: ['items', undefined, value => value],
            streamId: ['streamId', undefined],
        }
    };

    static attributeLabels = {
        id: 'ID',
        carId: 'ID автомобиля',
        mileage: 'Пробег',
        status: 'Статус',
        sum: 'Общая сумма',
        date: 'Дата',
        station: 'СТО',
        recommendation: 'Общие рекомендации',
        works: 'Работы',
        items: 'Материалы',
    }

    getStreamUrl() {
        let result = ''

        if (this.streamId) {
            const now = Math.floor(Date.now() / 1000)
            const apiUrl = process.env.VUE_APP_API_URL
            result = apiUrl + 'stream/?streamId=' + this.streamId + '&date=' + now
        }

        return result
    }
}

export default OrderModel
